<template>
    <div class="footer">
        <div class="border"></div>
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="copyright">
                            © {{$t('footer.poweredBy')}} {{copyright}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {DateTime} from "luxon"

    export default {
        name: "Footer",
        data() {

            return {
                copyright: `${DateTime.local().year} ${process.env.VUE_APP_COPYRIGHT}`
            }
        }
    }
</script>